//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formartRoute } from '@/utils/util';
export default {
  props: {
    topic: {
      type: Object,
      required: true,
    },
    cardWidth: {
      type: String,
      default: '282px',
    },
  },
  methods: {
    goToStockDetail(stock) {
      if (stock.market) {
        window.location.href = `/stock/${stock.market}${stock.code}`;
      }
    },
    goToTopicSummary(topic) {
      if (topic.summaryRoute) {
        const link = formartRoute(topic.summaryRoute);
        window.location.href = link;
      }
    },
  },
};
